import { useCallback } from 'react';

export default function useScrollToId(offset = 0) {
  return useCallback((id) => {
    const el = document.getElementById(id);
    if (!el) return;

    const rect = el.getBoundingClientRect();
    const viewportHeight = window.innerHeight;

    // Check if element is already in view (with offset consideration)
    const isInView =
      rect.top >= offset &&
      rect.bottom <= viewportHeight;

    if (isInView) return;

    const y = rect.top + window.scrollY - offset;

    window.scrollTo({
      top: y,
      behavior: 'smooth',
    });
  }, [offset]);
}